import React from "react"
import { Link } from "gatsby"
import funlearning from "../../../images/funlearning-banner.png"
import clock from "../../../images/clock.png"
import "./FunLearning.scss"

const FunLearning = () => {
	return (
		<div className="kids fun-learning learning">
			<img src={funlearning} alt="fun learning" />
			<div className="content">
				<h2>JUMP INTO EPIC STORIES</h2>
				<div className="completion-time">
					<div className="completion-time-image">
							<img src={clock} alt="clock" />
					</div>
					<div className="completion-time-description">
						<p className="completion-time-p">It takes 1 hour to earn your PhoneSmart Licence</p>
					</div>
				</div>
				<p>Now you've got your new phone, it's time to learn some new skills with our epic interactive stories.
				Meet the gang, play fun quizzes and win stickers to earn your PhoneSmart Licence.</p>
			</div>
		</div>
	)
}

export default FunLearning
